const replaceLink = (embedUrl, link) => {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', embedUrl.trim());
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    iframe.style.width = '100%';
    iframe.style.aspectRatio = '16 / 9';
    iframe.style.maxWidth = '720px';
    iframe.style.maxHeight = '405px';
    link.parentNode.replaceChild(iframe, link);
}

export function replaceRutubePrivateLinks() {
    const rutubeLinks = Array.from(document.querySelectorAll('a[href*="rutube.ru/video/private"], p, span')).filter(link => link.textContent.includes('rutube.ru/video/private'));
    rutubeLinks.forEach(link => {
        let videoId = link.href ? link.href.split('/video/private/')[1]
            : link.textContent.split('rutube.ru/video/private/')[1].split(' ')[0];

        const embedUrl = `https://rutube.ru/play/embed/${videoId}`.replace('?r=plwd', '');

        replaceLink(embedUrl, link)
    });
}

export function replaceRutubeLinks() {
    const rutubeLinks = Array.from(document.querySelectorAll('a[href*="rutube.ru/video/"], p, span')).filter(link => link.textContent.includes('rutube.ru/video'));
    rutubeLinks.forEach(link => {
        let videoId = link.href ? link.href.split('/video/')[1]
            : link.textContent.split('rutube.ru/video/')[1].split(' ')[0];

        const embedUrl = `https://rutube.ru/play/embed/${videoId}`;

        replaceLink(embedUrl, link)
    });
}

export function findLink(url) {
    return url.toLowerCase().indexOf("rutube.ru/video") >= 0 || url.toLowerCase().indexOf("youtu.be/") >= 0 || url.toLowerCase().indexOf("youtube.com/watch") >= 0
}
